import React from 'react';
import FormTextField from './form-textfield';
import TaxCodeSelector from './tax-code-selector';
import {EXPENSE_JSON_IMPUTATION_LEVEL1_ID, EXPENSE_JSON_IMPUTATION_LEAF_ID} from '../pages/review-expense/utils/contract-expense-json';

export default function ExpenseItemFields({data, item, onChange, taxCodes, invoiceTaxCode, defaultTaxCode, locked = false, amountLocked = locked, focused = false}) {
    return (
        <div>
            <label className={"d-flex align-content-center mb-3"}>
                <span className={`col-3 my-auto font-weight-bold`}>
                    {data.t.read("invoice.amount")}<span>*</span>
                </span>
                <div className={"col-8 border p-0 rounded-lg"}>
                    <FormTextField
                        format="money"
                        locked={amountLocked}
                        classes={focused ? "border-highlight-secondary" : ""}
                        value={item.amounts_summary?.ItemSubTotal}
                        validateChange={val => onChange({...item, amounts_summary: {...item.amounts_summary, ItemSubTotal: val}})}
                    />
                </div>
            </label>
            <label className={"d-flex align-content-center mb-3"}>
                <span className={"col-3 my-auto"}>
                    {data.t.read("tips")}
                </span>
                <div className={"col-8 border p-0 rounded-lg"}>
                    <FormTextField
                        format="money"
                        locked={locked}
                        value={item.amounts_summary?.TipAllocatedToItem}
                        validateChange={val => onChange({...item, amounts_summary: {...item.amounts_summary, TipAllocatedToItem: val}})}
                    />
                </div>
            </label>
            <div className={"d-flex align-content-center mb-3"}>
                <label className={"col-3 my-auto"}>
                    {data.t.read("tax_code")}
                </label>
                <div className={"col-8  p-0 rounded-lg"}>
                    <TaxCodeSelector
                        taxCodes={taxCodes}
                        disabled={locked}
                        value={
                            item.TaxCode
                                ? item.TaxCode
                                : invoiceTaxCode
                                    ? invoiceTaxCode
                                    : defaultTaxCode
                        }
                        onChange={(newTaxCode) => onChange({...item, TaxCode: newTaxCode})}
                    />
                </div>
            </div>
            {(item?.Category ||
              item?.[EXPENSE_JSON_IMPUTATION_LEVEL1_ID] ||
              item?.[EXPENSE_JSON_IMPUTATION_LEAF_ID]) && (
                <div className="border-top pt-3 mt-2 small text-muted" data-testid="invoice-expense-coding-readonly">
                    <p className="font-weight-bold text-body mb-2">
                        {data.t.read('invoice.expense_coding_snapshot')}
                    </p>
                    {item.Category ? (
                        <div className="mb-1">
                            <span className="font-weight-bold">{data.t.read('category')}: </span>
                            {item.Category}
                        </div>
                    ) : null}
                    {item[EXPENSE_JSON_IMPUTATION_LEVEL1_ID] ? (
                        <div className="mb-1">
                            <span className="font-weight-bold">{data.t.read('field_imputation_level1')}: </span>
                            {String(item[EXPENSE_JSON_IMPUTATION_LEVEL1_ID])}
                        </div>
                    ) : null}
                    {item[EXPENSE_JSON_IMPUTATION_LEAF_ID] ? (
                        <div className="mb-1">
                            <span className="font-weight-bold">{data.t.read('field_imputation_subcategory')}: </span>
                            {String(item[EXPENSE_JSON_IMPUTATION_LEAF_ID])}
                        </div>
                    ) : null}
                </div>
            )}
        </div>
    );
}
